export const keys: <T extends object, K extends Extract<keyof T, string>>(
  o: T,
) => K[] = Object.keys

export const values: <T extends object, K extends Extract<keyof T, string>>(
  o: T,
) => T[K][] = Object.values

export const entries: <T extends object, K extends Extract<keyof T, string>>(
  o: T,
) => [K, T[K]][] = Object.entries

export const nonNullable = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined
